import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PageCard, Grid, testClass } from 'omni-common-ui';
import classnames from 'classnames';

import ExpansionButton from 'components/ExpansionButton';
import ReadOnlyField from '../ReadOnlyField';

const TOTAL_SCORE = 'Total Score';
const COLUMNS_PER_ROW = 4;

class AssessmentResultsCard extends Component {
  render() {
    const {
      isExpanded,
      assessmentResultsInfo,
      onExpandButtonClick,
    } = this.props;

    let displayItems = assessmentResultsInfo.skillResults.map(({ name, score }) => ({
      title: name,
      value: score,
    }));

    if (!isExpanded && displayItems.length > COLUMNS_PER_ROW) {
      displayItems = displayItems.slice(0, COLUMNS_PER_ROW);
    }

    return <PageCard className={classnames(styles.AssessmentResultsCard_container, testClass('assessment-results-card'))}>
      <PageCard.Heading className={styles.AssessmentResultsCard_heading}>
        <span>Assessment results</span>
      </PageCard.Heading>
      <PageCard.Content className={styles.AssessmentResultsCard_content}>
        <Grid className={styles.AssessmentResultsCard_grid}>
          <Grid.Group className={styles.AssessmentResultsCard_totalScoreRow}>
            <Grid.Item xs={12}
                sm={3}
                md={3}
                className={styles.AssessmentResultsCard_item}>
              <ReadOnlyField boardTitle={TOTAL_SCORE}
                  boardValue={assessmentResultsInfo.totalScore}
                  hideDivider />
            </Grid.Item>
          </Grid.Group>
          <Grid.Group>
            {displayItems.map((source) => (
              <Grid.Item key={source.title}
                  xs={12}
                  sm={3}
                  md={3}
                  className={styles.AssessmentResultsCard_item}>
                <ReadOnlyField boardTitle={source.title}
                    boardValue={source.value}
                    hideDivider />
              </Grid.Item>
            ))}
          </Grid.Group>
        </Grid>
      </PageCard.Content>
      <ExpansionButton isExpand={isExpanded}
          onExpansionButtonClick={() => onExpandButtonClick()} />
    </PageCard>;
  }
}

AssessmentResultsCard.propTypes = {
  assessmentResultsInfo: PropTypes.shape({
    totalScore: PropTypes.string.isRequired,
    skillResults: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      score: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onExpandButtonClick: PropTypes.func.isRequired,
};

export default AssessmentResultsCard;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/AssessmentResultsCard/index.jsx